module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./ProtectionView.js"));
	}, "ProtectionView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ProtectionView!./src/pages/Shop/Member/Personal/Protection/ProtectionView.js
// module id = 1003
// module chunks = 431